module.exports = __webpack_public_path__ + "static/media/mobile-repeat-teal.bafe2354.svg";